import type { TableOfContentsHeadingCreationPanelFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { AttributePanel } from "../AttributePanel";
import { useCreateTableOfContentsHeadingFromPanelMutation } from "../../client/generated";

type Props = {
  fragment: TableOfContentsHeadingCreationPanelFragment;
  onDelete: () => Promise<void>;
};

export function TableOfContentsHeadingCreationPanel({
  fragment,
  onDelete,
}: Props) {
  const { t } = useTranslation();
  const [createAttribute] = useCreateTableOfContentsHeadingFromPanelMutation();

  const onSave = async () => {
    await createAttribute({
      variables: {
        regionId: fragment.id,
      },
    });
    await onDelete();
  };

  return (
    <AttributePanel
      title={t("TableOfContentsHeadingCreationPanel.title")}
      unsaved
      onSubmit={onSave}
      onDelete={onDelete}
    />
  );
}
